import React from 'react';
import AuthConfirmContainer from '../components/authConfirm.container';

const AuthConfirmPage: React.FC = () => <AuthConfirmContainer />;

export default AuthConfirmPage;
